import React from "react";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExlySearchableDropdownV2 from "repoV2/features/Common/modules/Form/modules/ExlySearchableDropdownV2/ExlySearchableDrowpdownV2";
import checkoutCommonStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";
import {
    merchandise_total_inventory,
    selected_merchandise_quantity_form_key,
} from "../../MerchandiseDetailsFormGroup.constants";
import styles from "./MerchandiseQuantitySelector.module.scss";

const merchandise_initial_quantity = [
    ...Array(merchandise_total_inventory),
].map((i, idx) => ({
    id: `${idx + 1}`,
    label: `Quantity: ${idx + 1}`,
    value: `${idx + 1}`,
    selectedLabel: `${idx + 1}`,
}));

const MerchandiseQuantitySelector = (props: {
    totalQuantity: number;
    isVariantSelected: boolean;
    isVariantMerchandise: boolean;
}) => {
    const { totalQuantity, isVariantSelected, isVariantMerchandise } = props;

    const [merchandiseQuantityOptions, setMerchandiseQuantityOptions] =
        React.useState(merchandise_initial_quantity);

    React.useEffect(() => {
        const options = [...Array(totalQuantity)].map((i, idx) => ({
            id: `${idx + 1}`,
            label: `Quantity: ${idx + 1}`,
            value: `${idx + 1}`,
            selectedLabel: `Quantity: ${idx + 1}`,
        }));
        setMerchandiseQuantityOptions(options);
    }, [totalQuantity]);

    return (
        <div className={styles.mainContainer}>
            <div className={checkoutCommonStyles.dropdownBorderStyles}>
                <ExlySearchableDropdownV2
                    name={selected_merchandise_quantity_form_key}
                    options={merchandiseQuantityOptions}
                    renderOption={option => <>{option.value}</>}
                    classes={{
                        textInput: checkoutCommonStyles.inputBaseText,
                        helperText: checkoutCommonStyles.dropdownHelperText,
                        placeholder: checkoutCommonStyles.placeholderText,
                        inputRoot: checkoutCommonStyles.selectInput,
                        listbox: checkoutCommonStyles.selectMenuStyle,
                    }}
                    ExpandIcon={<ExpandMore />}
                    disabled={isVariantMerchandise && !isVariantSelected}
                />
            </div>
        </div>
    );
};

export default MerchandiseQuantitySelector;
